// extracted by mini-css-extract-plugin
module.exports =  {"block":"zHp3lqUOAed8PDgaAor2","vertical":"CkyyoOQNJd5aKgSkVelQ","standard":"eaUwYu9eoyjT7A3PF_ZA","horizontal":"R6f0GpTPgkmB2jK9JvTl","input":"vAuK970CU456wEcOxt93"};